import { useCallback, useRef, useState } from "react";

// Slider avant / après — faites glisser la séparation entre les deux photos.
export const BeforeAfterSlider = ({ before, after, altBefore, altAfter, ratio = "aspect-[4/3] sm:aspect-[3/2]" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const [dragging, setDragging] = useState(false);

  const update = useCallback(
    (clientX) => {
      const rect = ref.current?.getBoundingClientRect();
      if (!rect) return;
      const pct = ((clientX - rect.left) / rect.width) * 100;
      setPos(Math.min(96, Math.max(4, pct)));
    },
    []
  );

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className={`relative w-full cursor-ew-resize select-none overflow-hidden bg-card ${ratio}`}
      onPointerDown={(e) => {
        setDragging(true);
        update(e.clientX);
      }}
      onPointerMove={(e) => dragging && update(e.clientX)}
      onPointerUp={() => setDragging(false)}
      onPointerLeave={() => setDragging(false)}
    >
      <img src={after} alt={altAfter} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
      <img
        src={before}
        alt={altBefore}
        draggable={false}
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      <span className="absolute left-5 top-5 bg-ink/70 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-cream backdrop-blur">
        Avant
      </span>
      <span className="absolute right-5 top-5 bg-neon px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-ink">
        Après
      </span>
      <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="h-full w-px bg-neon" />
        <div
          className="absolute top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-neon bg-ink/80 text-neon backdrop-blur"
          data-testid="before-after-handle"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
          </svg>
        </div>
      </div>
    </div>
  );
};
